import { axiosInstance } from '@/plugins/axios';
import { modicareAxiosInstance } from '@/plugins/modicare-axios';
import { useUserStore } from '@/stores/userStore';

const userService = {

  
  async createUser(data) {
    const response = await axiosInstance.post('/users/register', data);
    return response.data;
  },
  async loginCmsUser(data) {
    // const response = await modicareAxiosInstance.post('/consultant/login/mw', data);
    const response = await axiosInstance.post('/users/adminlogin', data);
    return response.data;
  },
  async loginUser(data) {
    // const response = await modicareAxiosInstance.post('/consultant/login/mw', data);
    const response = await axiosInstance.post('/users/login', data);
    return response.data;
  },
  async getUserDetails(data){
    const response2 = await axiosInstance.get('/users/profile',
      {
        headers: {
          Authorization: `Bearer ${data}`,
        },
      }
    );
    return response2.data;
  },
  async updateUserProfile(token, requestData) {
    const response = await axiosInstance.put('/users/profile', requestData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
  async logoutUser(data) {
    const userStore = useUserStore();
    userStore.cartId=null;
    // Retrieve the access token from the store
    const accessToken = userStore.getApiAccessToken;
      const response = await axiosInstance.post('/users/logout', data,
        {
        headers: {
          Authorization: `Bearer ${accessToken}`,
  },});
      return response.data;
  },
  async logoutCmsUser(data) {
    // userStore.cartId=null;
    // Retrieve the access token from the store
    const userStore = useUserStore();
    let refreshToken={refreshToken:data};
      const response = await axiosInstance.post('/users/adminlogout',refreshToken, 
        {
        headers: {
          Authorization: `Bearer ${userStore.getAdminAccessToken}`,
  },});
      return response.data;
  },
   async updatePanDetails(panNo) {
    const userStore = useUserStore();
    const accessToken = userStore.getApiAccessToken;
    return await modicareAxiosInstance.put(`/consultant/pan`,
      { pan_no: panNo },
      {
        headers: {
          "x-auth-token": accessToken,
        },
      }
    );
  },
   async updateContact(mobile_number) {
    const userStore = useUserStore();
    const accessToken = userStore.getApiAccessToken;
    return await modicareAxiosInstance.put(`/consultant/mobile`,
      { mobile_no: mobile_number },
      {
        headers: {
          "x-auth-token": accessToken,
        },
      }
    );
  },
   async updateEmail(email) {
    const userStore = useUserStore();
    const accessToken = userStore.getApiAccessToken;
    return await modicareAxiosInstance.put(
      `${process.env.VUE_APP_BASE_MODICARE_API_URL}/consultant/email`,
      { email_id: email },
      {
        headers: {
          "m-key": "Y8S3TA-7R3NGQ-TPJ9T6-98709",
          "x-auth-token": accessToken,
        },
      }
    );
  },
   async updateNEFTDetails(confirm_account_number, account_holder_name, ifsc_code, bank_name) {
    const userStore = useUserStore();
    const accessToken = userStore.getApiAccessToken;
    return await modicareAxiosInstance.put(
      `${process.env.VUE_APP_BASE_MODICARE_API_URL}/consultant/neft`,
      {
        "account_no": confirm_account_number,
        "account_name": account_holder_name,
        "ifsc_code": ifsc_code,
        "bank_name": bank_name

    },
      {
        headers: {
          "m-key": "Y8S3TA-7R3NGQ-TPJ9T6-98709",
          "x-auth-token": accessToken,
        },
      }
    );
  },
   async pcToconsultant(mca_no, aadharId) {
    const userStore = useUserStore();
    const accessToken = userStore.getApiAccessToken;
    return await modicareAxiosInstance.post(
      `/consultant/pctoconsultant`,
      {
       "mca_no": mca_no,
      "kyc_no": aadharId

    },
      {
        headers: {
          "x-auth-token": accessToken,
        },
      }
    );
  },

  async searchShippingPincode(searchValue) {
    try {
      const response = await axiosInstance.get(`/locations?search=${searchValue}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching shipping pincodes:", error);
      throw error; // Rethrow the error to handle it in the calling component
    }
  },

  
};

export default userService;